import Sticky from 'Components/Sticky';
import React from 'react';
import { connect } from 'react-redux';
import { TabContent, TabPane, Nav, NavItem, NavLink, Input, Table, Button } from 'reactstrap';

const LOCATION_NETWORK = 'location_network';
const PENDING = 'pending';

class Settings extends React.Component {
  constructor() {
    super();
  }
  render() {
    return (
        <Sticky activeLink={'settings'}>
            <div className="fixedCenter">
                <div className="fs-40 theme-color tCenter mb-10">
                    Nope! not so early.
                </div>
                <div className="fMedium fs-16 theme-color tCenter">
                    NB: Upcoming section
                </div>
            </div>
        </Sticky>
    );
  }
}

const mapStateToProps = ({trips}) => {
    return {
      }
};


export default connect(mapStateToProps)(Settings);


